module.exports = __webpack_public_path__ + "media/audio9.c9fa2f71.mp3";